"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CanvasWrapper;

var _react = _interopRequireWildcard(require("react"));

var THREE = _interopRequireWildcard(require("three"));

var _OrbitControls = require("three/examples/jsm/controls/OrbitControls");

var _reactThreeFiber = require("react-three-fiber");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, _reactThreeFiber.extend)({
  OrbitControls: _OrbitControls.OrbitControls
});

function Controls(_ref) {
  var _ref$isAutoRotating = _ref.isAutoRotating,
      isAutoRotating = _ref$isAutoRotating === void 0 ? false : _ref$isAutoRotating;

  var _useThree = (0, _reactThreeFiber.useThree)(),
      camera = _useThree.camera,
      gl = _useThree.gl;

  var ref = (0, _react.useRef)(null);
  var target = new THREE.Vector3(0, 0, 0);
  (0, _reactThreeFiber.useFrame)(function () {
    if (ref && ref.current) {
      ref.current.update();
    }
  });
  return /*#__PURE__*/_react.default.createElement("orbitControls", {
    ref: ref,
    target: target,
    args: [camera, gl.domElement],
    autoRotate: isAutoRotating,
    autoRotateSpeed: 0.2,
    enableZoom: true,
    maxDistance: 250,
    minDistance: 150,
    enablePan: false
    /* TODO
    keys={{
      LEFT: 0,
      UP: 0,
      RIGHT: THREE.MOUSE.ROTATE,
      BOTTOM: 0,
    }}
    */

  });
}

function Dome(_ref2) {
  var panoramaFile = _ref2.panoramaFile;
  var loader = new THREE.TextureLoader();
  loader.crossOrigin = "";
  var texture = loader.load(panoramaFile); // flip texture horizontally

  texture.wrapS = THREE.RepeatWrapping;
  texture.repeat.x = -1;
  return /*#__PURE__*/_react.default.createElement("mesh", null, /*#__PURE__*/_react.default.createElement("sphereBufferGeometry", {
    attach: "geometry",
    args: [500, 60, 40]
  }), /*#__PURE__*/_react.default.createElement("meshBasicMaterial", {
    attach: "material",
    map: texture,
    side: THREE.BackSide
  }));
}

function CanvasWrapper(_ref3) {
  var panoramaFile = _ref3.panoramaFile,
      _ref3$isAutoRotating = _ref3.isAutoRotating,
      isAutoRotating = _ref3$isAutoRotating === void 0 ? false : _ref3$isAutoRotating,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? "" : _ref3$className,
      style = _ref3.style;
  return /*#__PURE__*/_react.default.createElement(_reactThreeFiber.Canvas, {
    className: className,
    style: style
  }, /*#__PURE__*/_react.default.createElement(Controls, {
    isAutoRotating: isAutoRotating
  }), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: null
  }, /*#__PURE__*/_react.default.createElement(Dome, {
    panoramaFile: panoramaFile
  })));
}